<template>
  <div v-show="showOverlay"
       class="popup-wrap"
       :class="{'popup-wrap_right': showRightPopup}">
    <div :key="'overlay'"
    class="modal-overlay"
         v-show="showOverlay"
         @click="closeAll">
    </div>
    <transition name="form-show">
      <error-login :key="'error-login'"
                 v-if="showErrorLogin"></error-login>
    </transition>

    <transition name="form-show">
      <de-item-confirm-popup v-if="showDelItem"
                     :key="'delConfirm'"></de-item-confirm-popup>
    </transition>

    <transition name="form-show">
      <add-user v-if="addUserShow"
              :key="'addUser'"></add-user>
    </transition>


    <transition name="form-show">
      <recovery-success v-if="showRecoveryThanks"></recovery-success>
    </transition>


    <transition name="form-show">
      <add-thing v-if="setAddThingShow"></add-thing>
    </transition>

    <transition name="form-show">
      <add-role v-if="showAddRole"></add-role>
    </transition>

    <transition name="form-show">
      <add-role-in-group v-if="showAddRoleInGroup"></add-role-in-group>
    </transition>

    <transition name="form-show">
      <assign-role-in-group v-if="showAssignRoleToGroup"></assign-role-in-group>
    </transition>

    <transition name="form-show">
      <del-popup v-if="showDelPopup"></del-popup>
    </transition>

    <transition name="form-show">
      <unset-group v-if="showUnsetGroup"></unset-group>
    </transition>

    <transition name="form-show">
      <reinvite-popup v-if="showReinvite"></reinvite-popup>
    </transition>

    <transition name="form-show">
      <del-thing-confirm v-if="showDelThingConfirm"></del-thing-confirm>
    </transition>

    <transition name="form-show">
      <share-to-role v-if="showShareThing"></share-to-role>
    </transition>

    <transition name="form-show">
      <thing-rights-control v-if="showThingRightsControl"></thing-rights-control>
    </transition>

    <transition name="form-show">
      <change-owner-thing v-if="showChangeOwnnerThing"></change-owner-thing>
    </transition>

    <transition name="form-show">
      <error-merge-thing v-if="showErrorMergeThing"></error-merge-thing>
    </transition>

    <transition name="form-show">
      <create-project v-if="showCreateProject"></create-project>
    </transition>

    <transition name="form-show">
      <add-permission-project v-if="showAddPermissionProject"></add-permission-project>
    </transition>

    <transition name="form-show">
      <add-section-project v-if="showAddSectionProject"></add-section-project>
    </transition>

    <transition name="form-show">
      <del-project-item v-if="showDelItemProject"></del-project-item>
    </transition>

    <loader v-if="showLoader"></loader>


    <transition name="form-right">
      <show-more-user v-if="editUser"
                      :key="'show-more-user'"></show-more-user>
    </transition>



    <transition name="form-show">
      <addInfoBlock v-if="showAddInfoBlock"></addInfoBlock>
    </transition>

    <transition name="form-show">
      <addEventName v-if="showAddEventName"></addEventName>
    </transition>

    <transition name="form-show">
      <delSingleProject v-if="showDelSingleProject"></delSingleProject>
    </transition>

    <transition name="form-show">
      <del-role-project v-if="showDelRoleProject"></del-role-project>
    </transition>

    <transition name="form-show">
      <add-thing-in-porject v-if="showAddThingInProject"></add-thing-in-porject>
    </transition>

    <transition name="form-show">
      <remove-thing-project v-if="showRemoveThingProject"></remove-thing-project>
    </transition>

  </div>
</template>

<script>
  import {popups} from "../../mixins/popups";
  import errorLogin from './Login/errorLogin'
  import deItemConfirmPopup from './delItemConfirm'
  import addUser from './roles/user/addUser'
  import showMoreUser from './roles/user/showMore'
  import {mapState} from 'vuex'
  import recoverySuccess from './Login/recoverySuccess'
  import addThing from './things/addThing'
  import addRole from './roles/addRole'
  import addRoleInGroup from './roles/addInGroup'
  import assignRoleInGroup from './roles/assignInGroup'
  import delPopup from './confirm/delPopup'
  import unsetGroup from './confirm/unsetGroup'
  import reinvitePopup from './users/reinvitePopup'
  import loader from './loader'
  import delThingConfirm from './confirm/things/delThing'
  import shareToRole from './things/thingRights/shareToRole'
  import thingRightsControl from './things/thingRights/thingRightsControl'
  import changeOwnerThing from './things/thingRights/changeOwner'
  import errorMergeThing from './things/errorMerge'
  import createProject from './projects/addProject'
  import addPermissionProject from './projects/addPermissionProject'
  import addSectionProject from './projects/addSection'
  import delProjectItem from './projects/delProjectItem'
  import delRoleProject from './projects/removeRole'
  import addThingInPorject from './projects/addThing'
  import removeThingProject from './projects/removeThing'

  //new popup for journal
  import addInfoBlock from './journal/addInfoBlock'
  import addEventName from '../../components/Popups/journal/addEventName'
  import delSingleProject from '../../components/Popups/confirm/projectsPage/delSingleProject'

  export default {
    name: 'allPopups',
    mixins: [popups],
    components: {
      deItemConfirmPopup,
      errorLogin,
      addUser,
      showMoreUser,
      recoverySuccess,

      addThing,
      addRole,
      addRoleInGroup,
      assignRoleInGroup,
      delPopup,
      unsetGroup,
      reinvitePopup,
      loader,
      delThingConfirm,
      shareToRole,
      thingRightsControl,
      changeOwnerThing,
      errorMergeThing,
      createProject,
      addPermissionProject,
      addSectionProject,
      delProjectItem,
      addInfoBlock,
      delSingleProject,
      delRoleProject,
      addThingInPorject,
      removeThingProject,
      addEventName
    },
    computed: {
      ...mapState({
        showOverlay: state => state.popups.showOverlay,
        showErrorLogin: state => state.popups.errorLogin.showErrorLogin,
        showDelItem: state => state.popups.delItem.show,
        addUserShow: state => state.popups.addUser.show,
        addGroupShow: state => state.popups.addGroup.show,
        editUser: state => state.users.showEditUser,
        editGroup: state => state.users.showEditGroup,
        showRightPopup: state => state.popups.showRight,
        showRecoveryThanks: state => state.popups.errorLogin.showRecoverySuccess,
        setUserGroupShow: state => state.popups.setGroupUser.show,
        setAddThingShow: state => state.popups.addThing.show,
        showAddRole: state => state.popups.addRole.show,
        showAddRoleInGroup: state => state.popups.addRoleInGroup.show,
        showAssignRoleToGroup: state => state.popups.assignRole.show,
        showDelPopup: state => state.popups.del.show,
        showUnsetGroup: state => state.popups.del.showUnset,
        showReinvite: state => state.roles.inviteSuccess,
        showLoader: state => state.popups.loader,
        showDelThingConfirm: state => state.things.showDel,
        showShareThing: state => state.things.showShare,
        showThingRightsControl: state => state.things.showRightsControl,
        showChangeOwnnerThing: state => state.things.showChangeOwner,
        showErrorMergeThing: state => state.things.errorMergeThing,
        showCreateProject: state => state.projects.showCreateProject,
        showAddPermissionProject: state => state.projects.showAddPermission,
        showAddSectionProject: state => state.projects.showAddSection,
        showDelItemProject: state => state.projects.showDelPopup,
        showAddInfoBlock: state => state.popups.addInfoBlock.show,
        showAddEventName: state => state.journal.showAddEventNamePopup,
        showDelSingleProject: state => state.popups.delSingleProject.show,
        showDelRoleProject: state => state.projects.showDelRoleProject,
        showAddThingInProject: state => state.projects.showAddThingInProject,
        showRemoveThingProject: state => state.projects.showDelThingProject
      })
    }
  }
</script>
